import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {OrganiserPaymentDataService} from "@services";
import {OrganiserPaymentData} from "@model";

export const OrganiserPaymentDataResolver: ResolveFn<Observable<OrganiserPaymentData | null>> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   paymentDataService: OrganiserPaymentDataService = inject(OrganiserPaymentDataService)): Observable<OrganiserPaymentData | null> => {
    let currentPath: string | undefined = route.routeConfig?.path;
    switch (currentPath) {
      case 'organisers/edit':
        return paymentDataService.fetchOrganiserPaymentData(+route.queryParams['organiserId'], true);
      default:
        return paymentDataService.fetchOrganiserPaymentData(undefined, true);
    }
  }
